module.exports = __webpack_public_path__ + "img/warnIcon.08e7e0bb.svg";